uniform sampler2D uPerlinTexture;
uniform float uTime;
uniform float uTwist;

varying vec2 vUv;

#include ./includes/rotate2D.glsl

void main()
{
    vec3 newPosition = position;

    // Twist (no wind)
    float twistPerlin = texture(
        uPerlinTexture,
        vec2(0.5, uv.y * 0.2 - uTime * 0.02)
    ).r;
    float angle = twistPerlin * 10.0 * uTwist;
    newPosition.xz = rotate2D(newPosition.xz, angle);

    // Final position
    gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);

    // Varyings
    vUv = uv;
}